// Crossfade behavior for the slideshow section ("Fade between slides" setting).
// The section renders its wrapper as <fade-slideshow> in this mode, so Dawn's
// scroll-based slider component never attaches and this script owns navigation.
(() => {
  const init = (component) => {
    if (component.dataset.fadeInit) return;
    component.dataset.fadeInit = 'true';

    const slider = component.querySelector('.slideshow');
    const slides = Array.from(component.querySelectorAll('.slideshow__slide'));
    if (!slider || slides.length < 2) return;

    const dots = Array.from(component.querySelectorAll('.slider-counter__link'));
    const counterCurrent = component.querySelector('.slider-counter--current');
    let index = 0;
    let timer = null;

    const show = (next) => {
      next = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-shown', i === next);
        slide.setAttribute('aria-hidden', i === next ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('slider-counter__link--active', i === next);
        dot.setAttribute('aria-current', i === next ? 'true' : 'false');
      });
      if (counterCurrent) counterCurrent.textContent = next + 1;
      index = next;
    };

    const autoplay = slider.dataset.autoplay === 'true';
    const speed = (parseInt(slider.dataset.speed, 10) || 5) * 1000;
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const start = () => {
      if (autoplay && !timer) timer = setInterval(() => show(index + 1), speed);
    };
    const restart = () => {
      if (autoplay && timer) {
        stop();
        start();
      }
    };

    component.addEventListener('click', (event) => {
      const pause = event.target.closest('.slideshow__autoplay');
      if (pause) {
        pause.classList.toggle('slideshow__autoplay--paused');
        if (pause.classList.contains('slideshow__autoplay--paused')) stop();
        else start();
        return;
      }
      const prev = event.target.closest('.slider-button--prev');
      const next = event.target.closest('.slider-button--next');
      const dot = event.target.closest('.slider-counter__link');
      if (!prev && !next && !dot) return;
      event.preventDefault();
      if (prev) show(index - 1);
      else if (next) show(index + 1);
      else show(dots.indexOf(dot));
      restart();
    });

    let touchStartX = null;
    slider.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );
    slider.addEventListener(
      'touchend',
      (event) => {
        if (touchStartX === null) return;
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(deltaX) < 40) return;
        show(index + (deltaX < 0 ? 1 : -1));
        restart();
      },
      { passive: true }
    );

    component.classList.add('fade-init');
    show(0);
    start();
  };

  const initAll = (root) => root.querySelectorAll('fade-slideshow.slideshow--fade').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
